var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack2Company(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.595,
    height: 13.74,
    viewBox: "0 0 14.595 13.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5762",
    "data-name": "Group 5762",
    transform: "translate(-353.978 -608.44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5207",
    "data-name": "Path 5207",
    d: "M0,0,2.9,2.9,0,5.793",
    transform: "translate(357.935 614.763) rotate(180)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5208",
    "data-name": "Path 5208",
    d: "M7396.5,609.5h12.784v9.564h-6.357",
    transform: "translate(-7041.461 2.367)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack2Company);
export default __webpack_public_path__ + "static/media/back2company.8886946c7454bc8101bc9740176a221c.svg";
export { ForwardRef as ReactComponent };